"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
console.log('%c /init/init-licence.component.ts', 'color:white;background-color:gray;');
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const forms_1 = require("@angular/forms");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
const BaseComponent_1 = require("../commons/BaseComponent");
const app_service_1 = require("../commons/app.service");
const application_events_service_1 = require("../xs/services/events/application-events.service");
class InitLicenceComponent extends BaseComponent_1.BaseComponent {
    constructor(service, route, router, snackBar, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.route = route;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.isLicenceValid = false;
        this.checkingOther = false;
        this.passControl = new forms_1.FormControl('', [forms_1.Validators.required, forms_1.Validators.maxLength(3)]);
        this.licenceControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.addressControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.netmaskControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        this.gatewayControl = new forms_1.FormControl('', [forms_1.Validators.required]);
        console.log('%c /init/init-licence.component.ts CONSTRUCTOR', 'color:white;background-color:black;');
    }
    ngOnInit() {
        console.log('%c /init/init-licence.component.ts : onInit()', 'color:white;background-color:black;');
        this.route.queryParams.subscribe(params => {
            //console.log("ENETR initComponent params: ",params)
            this.status = params["status"];
            this.message = params["msg"];
        });
        this.checkLicence();
    }
    onStepChanged(event) {
        // When optional network check then query network details from the server
        if (event.selectedIndex == 2 && !this.networkInterfaces) {
            this.checkNetwork();
        }
    }
    checkLicence() {
        console.log('%c /init/init-licence.component.ts : checkLicence()', 'color:white;background-color:black;');
        this.loading = true;
        this.service.V.api("/access/login/website", "get")
            .subscribe(res => {
            this.isLicenceValid = true;
            this.loading = false;
        }, err => {
            // This error status means the user has already logged in, therefore licence must be valid
            if (err.status == 4032) {
                this.isLicenceValid = true;
                this.loading = false;
            }
            else {
                this.isLicenceValid = false;
                this.loading = false;
            }
        });
    }
    checkNetwork() {
        console.log('%c /init/init-licence.component.ts : checkNetwork()', 'color:white;background-color:black;');
        this.selectedInterface = null; // reset
        this.checkingOther = true;
        let loginObs;
        if (this.service.V.localSession()) {
            // If we have a valid session we assume is an admin so use it
            loginObs = rxjs_1.of(true);
        }
        else if (this.passControl.value) {
            // If no session but still have the password use it to login
            loginObs = this.service.V.loginWithUsernameObservable("admin", this.passControl.value);
        }
        else {
            // Otherwise ask for password and use it.
            loginObs = this.openDialog("INIT.ADMIN_PW", null, null, null, true).pipe(operators_1.flatMap(pass => this.service.V.loginWithUsernameObservable("admin", pass)));
        }
        loginObs.pipe(operators_1.flatMap(res => this.service.V.api("/admin/network", "get"))).subscribe(res => {
            this.networkInterfaces = res;
            // Try to selected the default interface to configure
            this.selectedInterface = res.find(ele => (ele.name.toLowerCase().startsWith("e") && ele.ip4));
            this.checkingOther = false;
        }, err => {
            this.checkingOther = false;
        });
    }
    setNetwork(netIf) {
        this.addressControl.setValue(netIf.ip4);
        this.netmaskControl.setValue("");
        this.gatewayControl.setValue("");
    }
    validateLicence(stepper, licence) {
        console.log('%c /init/init-licence.component.ts : validateLicence()', 'color:white;background-color:black;');
        // Trigger vasat licence check end-point passing the licence key
        let args = { key: licence };
        this.loading = true;
        this.service.V.api("/vasat/license/update", "post", args)
            .subscribe(res => {
            this.loading = false;
            this.isLicenceValid = true;
            //stepper.next()
            this.openSnackBarSuccess('GENERIC.SUCCESS');
        }, err => {
            this.loading = false;
            this.openSnackBarError(err.message);
        });
    }
    networkSetup(netIf) {
        console.log('%c /init/init-licence.component.ts : networkSetup()', 'color:white;background-color:black;');
        let loginObs;
        let args = {
            name: netIf.name,
            address: this.addressControl.value,
            netmask: this.netmaskControl.value
        };
        if (this.gatewayControl.value) {
            args["gateway"] = this.gatewayControl.value;
        }
        if (this.service.V.localSession()) {
            // If we have a valid session we asume is an admin so use it
            loginObs = rxjs_1.of(true);
        }
        else if (this.passControl.value) {
            // If no session but still have the password use it to login
            loginObs = this.service.V.loginWithUsernameObservable("admin", this.passControl.value);
        }
        else {
            // Otherwise ask for password and use it.
            loginObs = this.openDialog("INIT.ADMIN_PW", null, null, null, true).pipe(operators_1.flatMap(pass => this.service.V.loginWithUsernameObservable("admin", pass)));
        }
        loginObs.pipe(operators_1.flatMap(res => this.service.V.api("/admin/network", "post", args)))
            .subscribe(res => {
            this.checkingOther = false;
            this.openSnackBarSuccess('GENERIC.SUCCESS');
            // Reset to check changes applied
            //this.checkNetwork()
        }, err => {
            this.checkingOther = false;
            this.openSnackBarError(err.message);
        });
    }
}
exports.InitLicenceComponent = InitLicenceComponent;
